import { FormatAlignJustifyTwoTone } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { LoadingPage } from "../LoadingPage";
import { AuthUserContext, withAuthorization } from "../Session";
import { EvaluationResult } from "./EvaluationResult";
import * as ROUTES from "../../constants/routes";

const EvaluationPassed = (props) => {
  const { uid, course, attemp } = useParams();
  const { firebase } = props;
  const history = useHistory();
  const [attempData, setAttempData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isReviewed, setIsReviewed] = useState(false);

  useEffect(() => {
    firebase
      .evaluationAttemp(uid, course, attemp)
      .once("value")
      .then((snap) => {
        setAttempData(snap.val());
        setIsLoaded(true);
      })
      .catch((error) => {
        history.push(ROUTES.ERROR);
      });
    const metadataRef = firebase.evaluationMetadata(firebase.currentUser().uid, course);
    metadataRef.once("value").then((snap) => {
      const isRev = snap.val()?.isReviewed;
      setIsReviewed(isRev);
      !isRev && metadataRef.update({ isReviewed: true });
    });
  }, []);

  return isLoaded ? (
    <AuthUserContext.Consumer>
      {(authUser) => <EvaluationResult attemp={attempData} nAttemp={parseInt(attemp)} course={course} hitRatio={1} userInfo={authUser} isReviewed={isReviewed} />}
    </AuthUserContext.Consumer>
  ) : (
    <LoadingPage />
  );
};

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(EvaluationPassed);
